import { render } from "./Deadline.vue?vue&type=template&id=01f9377d"
import script from "./Deadline.vue?vue&type=script&lang=js"
export * from "./Deadline.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__